export default `<p><strong>IC Markets</strong> 为已授权的稳定币资产提供透明、分档的每日收益计划。您的日收益由链上授权余额（USD 等值）及下方对应档位的日化收益率决定。档位利率由平台配置实时读取并展示。</p>

<h2>一、收益机制说明</h2>
<p>当您在 <strong>IC Markets</strong> 通过 Web3 钱包完成 USDT 或 USDC 链上授权后，系统将以您的链上授权可用余额作为计息基础。每个自然日，平台依据以下规则生成结算订单（USDT 与 USDC 分别计息、分别累计）：</p>
<ul>
  <li><strong>链上本金：</strong>结算时刻的授权稳定币余额（USD 等值）；</li>
  <li><strong>档位利率：</strong>根据链上本金所在区间，匹配下方收益阶梯表中的基准日化收益率；</li>
  <li><strong>复利模式（默认）：</strong>日收益 ≈（链上授权余额 + 该币种累计未提现收益）× 日化收益率 ÷ 100；</li>
  <li><strong>单利模式（如平台开启）：</strong>日收益 ≈ 链上授权余额 × 日化收益率 ÷ 100。</li>
</ul>
<p>平台收益提现仅影响账户可提现余额及复利累计基数，<strong>不影响链上钱包余额</strong>。结算频率为<strong>每日四次</strong>，收益累计计入账户，可在「资产 → 结算订单」中查看明细。历史收益不代表未来表现。</p>

<h2>二、收益阶梯表</h2>
<p>下表展示 <strong>IC Markets</strong> 当前生效的授权余额档位与对应日化收益率。授权余额越高，可匹配的档位利率通常越高。表中利率均为<strong>日化百分比</strong>，非年化 APY。</p>
<!-- YIELD_TIER_TABLE -->
<p><strong>说明：</strong>系统在每个结算日自动根据您的<strong>链上授权余额</strong>匹配对应档位。若链上余额变动导致区间变化，下一结算日将按新档位利率执行。复利模式下，累计未提现收益参与计息但不改变档位匹配。</p>

<h2>三、档位匹配规则</h2>
<ul>
  <li>仅<strong>已完成链上授权（Approve）</strong>的 USDT / USDC 余额参与计息；</li>
  <li>低于最低档位门槛的余额不参与结算；</li>
  <li>每个档位对应一个 USD 余额区间，系统自动匹配唯一适用档位；</li>
  <li>若某档位配置为区间利率，则按最小与最大日化利率的平均值（(最小+最大)÷2）结算；</li>
  <li>档位配置可由平台运营方调整，变更仅对后续结算生效，不影响历史订单。</li>
</ul>

<h2>四、结算与展示</h2>
<h3>4.1 结算周期</h3>
<ul>
  <li><strong>结算频率：</strong>每个已授权资产每日结算四次；</li>
  <li><strong>首次结算：</strong>当日完成授权的钱包，从次日起开始计息结算；</li>
  <li><strong>订单字段：</strong>结算金额、币种（USDT / USDC）、适用利率、结算时间。</li>
</ul>
<h3>4.2 资产页指标</h3>
<p>在「资产」页可查看<strong>累计收益</strong>（历史结算总和）与<strong>今日收益</strong>（当日已结算部分），数据以系统订单记录为准。</p>

<h2>五、如何在 IC Markets 开始获取收益</h2>
<ol>
  <li>登录账户并连接 Web3 钱包（MetaMask 或兼容钱包）；</li>
  <li>在侧栏点击「立即加入」，选择 USDT 或 USDC；</li>
  <li>在钱包中确认链上 <strong>Approve（授权）</strong> 交易；</li>
  <li>授权成功后，系统将自动按余额匹配收益档位；</li>
  <li>在「资产」页查看每日结算订单与累计收益。</li>
</ol>

<h2>六、风险提示</h2>
<p><strong>IC Markets</strong> 采用非托管模式，平台不保管用户私钥。链上授权存在智能合约及市场风险，档位利率、池容量与结算结果可能发生变化。参与前请仔细阅读「规则与安全」页面。</p>

<p>— 档位利率数据同步自平台后端配置，页面展示仅供参考；最终结算金额以每日订单记录为准。</p>`
